import request from '@shared/api/request';
import { API_USERS_PATH } from '@shared/constants/pathsConstants';
import { User } from '@features/users/types';

export function getAllUsers() {
    return request.get(`/${API_USERS_PATH}/`);
}

export function getUserById(id: User['pk']) {
    return request.get(`/${API_USERS_PATH}/${id}/`);
}

export function getStudents() {
    return request.get(`/${API_USERS_PATH}/students/`);
}
